import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { LoginFormContainer } from './styled'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { useRecaptcha, withRecaptcha } from '../Recaptcha'

const useLoginForm = (initialValues, callback) => {
    const [inputs, setInputs] = useState(initialValues)
    const { getRecaptchaHeaders } = useRecaptcha()
    const handleSubmit = async event => {
        if (event) event.preventDefault()
        const headers = await getRecaptchaHeaders('login')
        callback(inputs, headers)
    }
    const handleInputChange = event => {
        event.persist()
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
    }
    return {
        handleSubmit,
        handleInputChange,
        inputs,
    }
}

const LoginForm = ({ onSubmit, loggingIn, ...props }) => {
    const emailRef = useRef(null)

    const { inputs, handleInputChange, handleSubmit } = useLoginForm(
        {
            email: '',
            password: '',
        },
        onSubmit
    )

    useEffect(() => {
        emailRef.current.focus()
    }, [emailRef])

    return (
        <LoginFormContainer {...props}>
            <div>
                <h1
                    className="!mb-6"
                    style={{
                        fontSize: '2.5rem',
                        fontWeight: 500,
                    }}
                >
                    Sign in
                </h1>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            className="form-control test-focus"
                            placeholder="Email"
                            type="text"
                            name="email"
                            value={inputs.email}
                            ref={emailRef}
                            onChange={handleInputChange}
                            data-testid="email"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className="form-control"
                            placeholder="Password"
                            type="password"
                            name="password"
                            value={inputs.password}
                            onChange={handleInputChange}
                            data-testid="password"
                        />
                    </div>
                    {props.error && (
                        <p className="!text-danger">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="!mr-2" />
                            {props.error}
                        </p>
                    )}
                    <div className="!flex !justify-between !items-center">
                        <button
                            className="btn btn-primary"
                            style={{
                                opacity: loggingIn ? 0.6 : 1,
                                pointerEvents: loggingIn ? 'none' : 'all',
                            }}
                            data-testid="sign-in"
                        >
                            {loggingIn ? 'Logging in...' : 'Sign In'}
                        </button>
                        <Link
                            to="/forgotten-password"
                            data-testid="forgotten-password"
                            style={{
                                color: '#007bff',
                            }}
                        >
                            Forgotten your password?
                        </Link>
                    </div>
                </form>
            </div>
        </LoginFormContainer>
    )
}

export default withRecaptcha(LoginForm)
